'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _templateData = require('redux/modules/templateData');

var templateActions = _interopRequireWildcard(_templateData);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Design = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    templates: state.company.design_templates,
    design_template_data: state.templateData.design_template_data
  };
}, (0, _extends3.default)({ pushState: _reactRouterRedux.push }, templateActions)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Design, _Component);

  function Design(props) {
    (0, _classCallCheck3.default)(this, Design);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Design.__proto__ || (0, _getPrototypeOf2.default)(Design)).call(this, props));

    _this.state = {
      templates: false
    };
    return _this;
  }

  (0, _createClass3.default)(Design, [{
    key: 'selectTemplate',
    value: function selectTemplate(template_id) {
      this.props.chooseTemplate(template_id);
      this.props.pushState('/choose-content');
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps) {
        this.setState({ templates: nextProps.templates });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (this.state.templates) {
        var cards = this.state.templates.map(function (template) {
          return _react2.default.createElement(
            'div',
            { key: template.id },
            _react2.default.createElement(
              'a',
              { onClick: function onClick() {
                  return _this2.selectTemplate(template.id);
                }, href: 'javascript:void(0)' },
              _react2.default.createElement('img', { src: template.image_url })
            )
          );
        });
        // const {info, load} = this.props; // eslint-disable-line no-shadow
        // const styles = require('./Design.scss');
        return _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'h3',
            null,
            'Choose your Design'
          ),
          cards
        );
      } else {
        return _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'h3',
            null,
            'Loading Please WAit'
          )
        );
      }
    }
  }]);
  return Design;
}(_react.Component), _class2.propTypes = {
  //info: PropTypes.object,
  //load: PropTypes.func.isRequired
}, _temp)) || _class);
exports.default = Design;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Preview/Preview.js
// module id = 1763
// module chunks = 0